export const getDestinationHelper = (content) => {
    // For South Turkey send Antalya as a destination
    if (content.destination_code === "AYT") return "Antalya";

    return content.title;
}